import { Customizations, Visibility } from 'models'
import useGetCurrentCustomization from './useGetCurrentCustomization'

const useGetCurrentVisibility = () => {
  const { currentCustomization } = useGetCurrentCustomization()

  const visibility: Visibility = Object.keys(currentCustomization as Customizations).reduce(
    (acc, key) => {
      return {
        ...acc,
        [key]: currentCustomization[key as keyof typeof currentCustomization]
          ?.isDisplayed as boolean,
      }
    },
    {},
  ) as Visibility

  return { visibility }
}

export default useGetCurrentVisibility
